var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "arrow-btn",
    attrs: {
      "to": _vm.link
    }
  }, [_c('span', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v("더보기")]), _c('div', {
    staticClass: "arrow-wrap"
  }, [_c('i', {
    staticClass: "icon icon-right-arrow2"
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }